'use strict';

/**
 *
 * @name: apiNewsletterService
 *
 */

function apiNewsletterService ($rootScope, $http) {

  'ngInject';

  /**
   *
   * @PUBLIC
   *
   */

  function subscribe ({ email, offers }) {

    const target = $rootScope.apiUrlBak + '/newsletter-subscription'

    const payload = {
      email,
      offers
    }

    return $http.post(target, payload)
  }

  /**
   *
   * @PRIVATE
   *
   */

  return {
    subscribe
  };
}

export default apiNewsletterService;



// WEBPACK FOOTER //
// ./app/components/_api/newsletter.service.js